
import React, { useEffect, useMemo } from 'react'
import WorksheetRail from './wsRail';
import { GradeToStringMapping, usePrintableWorksheetsState } from 'printableWorksheets/state';
import { DeviceTypes, useAppMediaProvider } from '../../../baseStyles/AppMediaProvider';
import { WorksheetsEnvironment } from 'printableWorksheets';
import AllWorksheetsScreen from '../views/AllWorksheetsScreen';
import './styles.scss'


const WSList = () => {

  const { viewData = [], worksheetsEnvironment, activeBreadcrumb, activeNode, activeGrade } = usePrintableWorksheetsState();
  const { currentDevice } = useAppMediaProvider();

  const isLastTopic: boolean = useMemo(() => {
    if(activeBreadcrumb.length > 0){
      const lastChild = activeBreadcrumb[activeBreadcrumb.length - 1];
      if(lastChild?.children?.length === 0){
        return true;
      }
    }
    return false;
  }, [activeBreadcrumb, viewData]);

  const sliceWorksheetsLength = useMemo(() => {
    // Klass container is always of width 960px i.e., close to tablet screen.
    if(worksheetsEnvironment === WorksheetsEnvironment.TEACHER_DASHBOARD){
      return 16;
    }
    
    switch(currentDevice){
      case DeviceTypes.Desktop:
        return 4;
      case DeviceTypes.Tablet:
        return 3;
      default:
        return 10;
    }
  }, [viewData, currentDevice]);

  useEffect(() => {
    const div = document.getElementById('printables-scrollable-div');
    if(div && div.scrollTop !== 0){
      div.scrollTop = 0;
    }
  }, [viewData, activeBreadcrumb])
  


  const renderRails = () => {
    return (
      <React.Fragment>
        {/* Worksheets of each topic */}
        {viewData?.map((item: any, index: any) => {
          return (
            <React.Fragment key={item.title+index}>
              <WorksheetRail
                title={item.title} 
                worksheets={item.worksheets?.length > sliceWorksheetsLength ? item.worksheets?.slice(0, sliceWorksheetsLength) : item.worksheets} 
                playblesCount={item.playblesCount}
                nodeId={item.nodeId}
                item={item}
              />
            </React.Fragment>
          )
        })}

        {/* All other worksheets of active topic */}
        {activeGrade && activeNode?.id ? (
          <div className={`all-ws`}>
            <div className='all-ws__title'>{`All ${activeNode?.title} worksheets for ${GradeToStringMapping[activeGrade]}`}</div>
            <div className="all-ws__list">
              <AllWorksheetsScreen nodeId={activeNode?.id} dontShowLoader/>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    )
  };

  const renderList = () => {
    return <AllWorksheetsScreen nodeId={activeBreadcrumb[activeBreadcrumb.length - 1]?.id} />
  }

  return (
    <div className={`ws-rails-container${currentDevice == DeviceTypes.Mobile ? ' mobile-view': ''}`}>
        {isLastTopic ? renderList() : renderRails()}
    </div>  
  )
}

export default WSList